// Leader dashboard
import React, { useCallback, useState } from 'react';
import View from 'src/pages/leaders/overview';
import AppRender from 'src/routes/app-render';
import { getMyOverview } from 'src/api/leaders/overview';

const Page = () => {

  const [data, setData] = useState({});
  const fetchData = useCallback(async () => {
    // getMyOverview(
    //   (result) => {
    //     setData(result);
    //   }
    // );
  }, []); 

  return (
    <AppRender apiCall={fetchData}>
      {data && <View items={data} />}
    </AppRender>
  );
};

export default Page;

